import IsiAnime from "./src/IsiAnime";

export default IsiAnime